import React from 'react'
import clsx from 'clsx'
import { useAppDispatch } from '../../../hooks/redux'
import { ArrowLeft } from 'iconsax-react'
import { useTheme } from '@mui/material'

import BaseModal from '../ChatModals/BaseModal2'
import Message from '../Message'
import Button from '../../atoms/Button2'
import { GreyButton } from '../../organisms/ChatWindowV2/Header/EditParticipantsModal'

import { deleteMessage } from '../../../slices/dms'
import { useBreakpoint } from '../../../providers/BreakpointProvider'
import { deleteEvent } from '../../../lib/api/events'
import useStyles from './styles'

interface DeleteMessageModalProps {
  onClose: () => void
  messageProps: any
}

const title = 'Delete message'

const DeleteMessageModal: React.FC<DeleteMessageModalProps> = ({
  onClose,
  messageProps
}) => {
  const dispatch = useAppDispatch()
  const theme = useTheme()
  const { isSmall: mobile, isMedium } = useBreakpoint()
  const classes = useStyles({})

  const paperProps = React.useMemo(() => {
    if (mobile) {
      //64px is nav bar
      const maxH = `calc(100% - 64px)`
      return {
        style: {
          top: '0',
          transform: 'translateX(-50%)',
          borderRadius: '0',
          width: '100vw',
          maxWidth: 'unset',
          minHeight: maxH,
          height: '100svh',
          maxHeight: maxH
        }
      }
    }

    return {
      style: {
        width: isMedium ? 'calc(100% - 4rem)' : '100%',
        maxWidth: isMedium ? 'unset' : '480px'
      }
    }
  }, [mobile, isMedium])

  const handleDelete = React.useCallback(async () => {
    if (messageProps.isDirect) {
      try {
        const id = messageProps.id
        dispatch(deleteMessage(id))
        await deleteEvent(id)
      } catch {}
    } else {
      // TODO: Add regular chat deleting
    }

    onClose()
  }, [onClose, messageProps.isDirect, dispatch, messageProps.id])

  return (
    <BaseModal
      open
      hideTitle={mobile}
      showX={!mobile}
      title={title}
      onClose={onClose}
      PaperProps2={paperProps}
      childrenClass={mobile && classes.mobileChildren}
    >
      <div className={clsx(classes.root, mobile && classes.mobileRoot)}>
        {mobile && (
          <div className={classes.mobileTitle}>
            <ArrowLeft
              variant='Linear'
              size={theme.size.xl}
              onClick={onClose}
              className={classes.mobileBackArrow}
            />

            <span>{title}</span>
          </div>
        )}

        <div className={classes.deleteMessage}>
          Are you sure you want to delete this message? This cannot be undone.
        </div>

        <div className={classes.messageHolder}>
          <Message {...messageProps} allowInteraction={false} />
        </div>

        <div
          className={clsx(
            classes.buttonArea,
            mobile && classes.buttonAreaMobile
          )}
        >
          <Button onClick={onClose} className={classes.button}>
            Cancel
          </Button>

          <GreyButton
            onClick={handleDelete}
            mobile={mobile}
            className={classes.button}
          >
            Delete
          </GreyButton>
        </div>
      </div>
    </BaseModal>
  )
}

export default DeleteMessageModal
